// global.js
// Source: https://github.com/maximakymenko/react-day-night-toggle-app/blob/master/src/global.js#L23-L41
// Modified for YTH Website

import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`

  body {
    margin: 0;
    text-align: center;
    font-family: "Lato";
    // -webkit-font-smoothing: antialiased;
    // -moz-osx-font-smoothing: grayscale;
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    // nicer text
    line-height: 1.5;
  }

  // Add dark mode transistions
  // class added to body in useDarkMode.js toggleTheme()
  .loaded {
    transition: background-color 0.25s linear,
                color 0.25s linear,
                box-shadow 0.25s linear;
  }

  a:link {
    color: ${({ theme }) => theme.link};
    transition: color 0.25s linear;
  }

  a:visited {
    color: ${({ theme }) => theme.link};
    transition: color 0.25s linear;
  }

  // Window contents
  .pagetitle {
    font-weight: 900;
    font-size: 24px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .title {
    font-weight: 900;
    font-size: 18px;
  }

  .text{
    text-align: left;
  }

  // Posts Page
  .directory {
    margin-left: auto;
    margin-right: auto;
    width: 80%;
  }

  .react-search-field {
    margin: 20px;
    border: 0px !important;
    width: 60%;
  }

  .react-search-field-input {
    border: 0px !important;
    border-radius: 5px;
    font-family: "Lato" !important;
    // background: black !important;
    background: ${({ theme }) => theme.hoverColor} !important;
    color: ${({ theme }) => theme.text} !important;
    transition: color 0.25s linear;
  }

  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${({ theme }) => theme.text} !important;
    transition: color 0.25s linear;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: ${({ theme }) => theme.text} !important;
    transition: color 0.25s linear;
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: ${({ theme }) => theme.text} !important;
    transition: color 0.25s linear;
  }

  .react-search-field-button {
    display: none;
  }

  ::-webkit-scrollbar {
    width: 6px;
    border-radius: 5px;
    background-color: ${({ theme }) => theme.windowBg};
  }
  ::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: ${({ theme }) => theme.windowBg};
    // color: white;
  }
  ::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: ${({ theme }) => theme.hoverColor};
  }

`;
